import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Link } from 'ui/links';
import { DefaultTriggerIcon, Popover, PopoverContent, PopoverTrigger } from 'ui/popover';
import { Caption, colors } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { AI_TERMS_OF_USE_URL } from 'modules/ai/constants';
import { getSelectedNodes } from 'modules/workflows/ducks';

const StyledPopoverContent = styled(PopoverContent)`
  max-width: ${pxToRem(216)};
`;

const StyledPopoverCaption = styled(Caption)`
  display: block;
  color: ${colors.textDisabled};

  a {
    color: inherit;
  }
`;

export const TERMS_POPOVER_ID = 'journey-assist-terms';

export const TermsPopover = () => {
  const selected = useSelector(getSelectedNodes);
  return (
    <Popover>
      <StyledPopoverContent TitleContent={'About tile generation'} id={TERMS_POPOVER_ID}>
        <p>
          Tiles are generated based only on the text input you provide.{' '}
          {selected.length > 0
            ? 'Selected tiles are not referenced.'
            : 'Historical journey data and performance is not referenced.'}
        </p>
        <StyledPopoverCaption>
          <Link
            size="caption"
            variant="monochrome"
            data-test="copy-assist-legal-terms"
            href={AI_TERMS_OF_USE_URL}
            rel="noreferrer noopener"
            target="_blank"
          >
            Terms
          </Link>{' '}
          apply with Iterable AI.
        </StyledPopoverCaption>
      </StyledPopoverContent>
      <PopoverTrigger Icon={DefaultTriggerIcon} />
    </Popover>
  );
};
